export default __webpack_public_path__ + "static/media/image-map-united-kingdom.f1e269b3.png";